
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import SavedRxListItem from '@/views/saved-rx-list/components/SavedRxListItem.vue';
	import { Property } from '@/store/prescription/prescriptionDefinition';
	import EditSVG from '@/components/EditSVG.vue';

	@Observer
	@Component({
		components: { SavedRxListItem, EditSVG }
	})
	export default class EndViewCategory extends Vue {
		@Prop({ required: false }) back?: (arg: string) => void;
		@Prop({ required: true }) disabledProps!: string[];
		@Prop({ required: true }) categoryName!: string;
		@Prop({ required: true }) category!: { title: string; display: string; properties: Property[] };
		private subProps = ['Specify Values', 'Extrinsic Specify Values', 'Intrinsic Specify Values'];

		isDisabled(prop) {
			return this.disabledProps.includes(prop);
		}

		propostringator(prop: Property) {
			if (this.subProps.includes(prop.options[prop.value]) && prop.subProperty) {
				if (prop.subProperty.subProperty) {
					if (prop.options[prop.value] !== this.subProps[0]) {
						return `
						<span class="prop-value-l">${prop.options[prop.value]}</span>
						<span class="prop-value-l">Left: ${prop.subProperty.options[prop.subProperty.value.l]} ${
							prop.subProperty.subProperty.options[prop.subProperty.subProperty.value.l]
						}</span>
						<span>Right: ${prop.subProperty.options[prop.subProperty.value.r]} ${prop.subProperty.subProperty.options[prop.subProperty.subProperty.value.r]}</span>`;
					}
					return `
						<span class="prop-value-l">Left: ${prop.subProperty.options[prop.subProperty.value.l]} ${
						prop.subProperty.subProperty.options[prop.subProperty.subProperty.value.l]
					}</span>
						<span>Right: ${prop.subProperty.options[prop.subProperty.value.r]} ${prop.subProperty.subProperty.options[prop.subProperty.subProperty.value.r]}</span>`;
				}
				return `
						<span class="prop-value-l">${prop.options[prop.value]}</span>
						<span class="prop-value-l">Left: ${prop.subProperty.options[prop.subProperty.value.l]}</span>
						<span>Right: ${prop.subProperty.options[prop.subProperty.value.r]}</span>`;
			}
			if (prop.value.l !== undefined) {
				if (prop.value.l.length !== undefined) {
					return `
						<span class="prop-value-l">Left: ${
							prop.value.l.length
								? [...prop.value.l]
										.sort()
										.map((v) => prop.options[v])
										.join(', ')
								: '-'
						}</span>
						<span>Right: ${
							prop.value.r.length
								? [...prop.value.r]
										.sort()
										.map((v) => prop.options[v])
										.join(', ')
								: '-'
						}</span>`;
				} else {
					return `
						<span class="prop-value-l">Left: ${prop.options[prop.value.l]}</span>
						<span>Right: ${prop.options[prop.value.r]}</span>`;
				}
			} else {
				if (prop.options[prop.value] === 'N/A') return '-';
				return `${prop.options[prop.value]}`;
			}
		}
	}
